module.exports = __webpack_public_path__ + "img/car-arrow-1.6f90d4dd.svg";